export const INITIALIZE_PRESS_RELEASE_PAGE = 'initialize-press-release-page';
const initializePressReleasePage = ({ pressReleaseSlug }) => ({
  type: INITIALIZE_PRESS_RELEASE_PAGE,
  payload: { pressReleaseSlug } });
export default initializePressReleasePage;
